import type { AchievementId } from "../services/AchievementService";

// A TrailPaletteDef is a 4-tier color list that PlayerTrail.setTierColors
// installs. Tier order is identical to MorphHexGame.comboTier:
//   index 0 -> combo  0..2 (cool / pristine)
//   index 1 -> combo  3..5 (mid)
//   index 2 -> combo  6..8 (hot)
//   index 3 -> combo  9+   (peak)
//
// Like skins, palettes can be gated behind a single AchievementId, or
// always available when `requires` is null. The default palette mirrors
// the original constant in PlayerTrail.

export interface TrailPaletteDef {
  id: string;
  name: string;
  colors: [number, number, number, number];
  requires: AchievementId | null;
}

export const TRAIL_PALETTES: TrailPaletteDef[] = [
  {
    id: "default",
    name: "Pristine",
    colors: [0xffffff, 0x2bd3ff, 0xff5cb1, 0xffd23f],
    requires: null,
  },
  {
    id: "ember",
    name: "Ember",
    colors: [0xfff1d6, 0xffba6b, 0xff5c3c, 0xffd23f],
    requires: "distance_500",
  },
  {
    id: "void",
    name: "Void",
    colors: [0xffffff, 0x6e3aff, 0xff5cb1, 0x9c66ff],
    requires: "perfect_100_total",
  },
  {
    id: "matrix",
    name: "Matrix",
    colors: [0xe6ffe1, 0x6bff9c, 0xb8ff5c, 0xffd23f],
    requires: "frenzy_first",
  },
];

export const DEFAULT_TRAIL_ID = "default";

export function trailById(id: string): TrailPaletteDef {
  return TRAIL_PALETTES.find((t) => t.id === id) ?? TRAIL_PALETTES[0]!;
}
